var _path, _path2, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatBotIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.81487 25.8432L12.128 23.1926L12.1281 23.1926C12.8048 22.6512 13.1432 22.3805 13.5201 22.188C13.8544 22.0172 14.2102 21.8923 14.578 21.8168C14.9925 21.7318 15.4259 21.7318 16.2926 21.7318H23.2541C24.3742 21.7318 24.9343 21.7318 25.3621 21.5138C25.7384 21.322 26.0444 21.0161 26.2361 20.6398C26.4541 20.2119 26.4541 19.6519 26.4541 18.5318V6.09844C26.4541 4.97833 26.4541 4.41828 26.2361 3.99046C26.0444 3.61413 25.7384 3.30817 25.3621 3.11642C24.9343 2.89844 24.3742 2.89844 23.2541 2.89844H4.6541C3.534 2.89844 2.97394 2.89844 2.54612 3.11642C2.1698 3.30817 1.86384 3.61413 1.67209 3.99046C1.4541 4.41828 1.4541 4.97833 1.4541 6.09844V18.5318C1.4541 19.6519 1.4541 20.2119 1.67209 20.6398C1.86384 21.0161 2.1698 21.322 2.54612 21.5138C2.97394 21.7318 3.534 21.7318 4.6541 21.7318H7.00966V24.9755C7.00966 25.7156 7.00966 26.0856 7.16136 26.2757C7.2933 26.441 7.49336 26.5371 7.70485 26.5369C7.94803 26.5366 8.23698 26.3055 8.81487 25.8432Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 9.37149C11.242 8.68083 11.7195 8.09844 12.3482 7.72747C12.9768 7.35651 13.7158 7.2209 14.4345 7.34468C15.1531 7.46845 15.805 7.84362 16.2745 8.40373C16.7441 8.96384 17.0011 9.67275 17 10.4049C17 12.4717 13.9125 13.5051 13.9125 13.5051V14.0351",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.9778,
    cy: 17.1177,
    r: 0.5,
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatBotIcon);
export default __webpack_public_path__ + "static/media/chatBotIcon.610a6fe87839b498ec071fa94cb2dfe3.svg";
export { ForwardRef as ReactComponent };